var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('EntityTable',{attrs:{"name":"Plugins","headers":_vm.plugin_headers,"items":_vm.plugins}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }